function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalePicker = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Text = require("../Text");
var _Button = require("../Button");
var _View = require("../View");
var _reactI18next = require("react-i18next");
var _utils = require("../../utils");
var _useLang = require("./useLang");
var _styles = require("./styles");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LocaleItem = (0, _react.memo)(function (_ref) {
  var lang = _ref.lang,
    label = _ref.label,
    itemStyle = _ref.itemStyle,
    onPress = _ref.onPress;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isActive = _useState2[0],
    _setIsActive = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    i18n = _useTranslation.i18n;
  var _onPress = function _onPress() {
    return onPress == null ? void 0 : onPress(lang);
  };
  (0, _react.useEffect)(function () {
    _setIsActive(i18n.language === lang);
  }, [i18n.language, lang]);
  return (0, _jsxRuntime.jsx)(_Button.Button, {
    type: _Button.ButtonType.link,
    onPress: _onPress,
    label: label,
    containerStyle: styles.localeItem,
    textStyle: [itemStyle, _isActive && styles.activeLocale],
    size: _Button.ButtonSize.small
  });
});
var LocalePicker = exports.LocalePicker = (0, _react.memo)(function (_ref2) {
  var containerStyle = _ref2.containerStyle,
    headingStyle = _ref2.headingStyle,
    headingTextStyle = _ref2.headingTextStyle,
    itemStyle = _ref2.itemStyle,
    itemTextStyle = _ref2.itemTextStyle,
    itemOnPress = _ref2.itemOnPress;
  (0, _useLang.useLang)();
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _useStyles2 = (0, _styles.useStyles)(),
    styles = _useStyles2.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: containerStyle,
    spacer: spacing.s,
    children: [(0, _jsxRuntime.jsx)(_Text.Text, {
      containerStyle: [styles.heading, headingStyle],
      textStyle: headingTextStyle,
      children: t('localePicker:heading')
    }), (0, _jsxRuntime.jsx)(_View.View, {
      style: [styles.locales, itemStyle],
      children: Object.keys(_utils.Locales).map(function (key, index) {
        return (0, _jsxRuntime.jsx)(LocaleItem, {
          label: _utils.Locales[key],
          lang: key,
          itemStyle: itemTextStyle,
          onPress: itemOnPress
        }, index);
      })
    })]
  });
});